import script from "./GameView.vue?vue&type=script&setup=true&lang=js"
export * from "./GameView.vue?vue&type=script&setup=true&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=04979b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04979b0a"]])

export default __exports__